module.exports = __webpack_public_path__ + "static/media/Post Street, San Francisco, CA1.37f3eec4.jpg";